module.exports = __webpack_public_path__ + "static/ff-landing-image-body-backdrop-ashleigh-shea-otVUcXqwqGM-unsplash.901d74fa.jpg";